import * as React from "react";
import PropTypes from "prop-types";

type SVGCheckProps = {
  //
};

const SVGCheck: React.FC<SVGCheckProps> = () => {
  return <svg width="60" height="40" className="tw-border tw-border-black tw-rounded" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" xmlSpace="preserve">
    <g>
      <g>
        <path d="M501.801,169.842h-41.254l31.127-31.128c3.983-3.983,3.983-10.441,0-14.425l-43.303-43.303    c-1.912-1.912-4.507-2.987-7.212-2.987s-5.3,1.075-7.212,2.987l-88.854,88.854H10.199C4.566,169.841,0,174.407,0,180.04v243.761    c0,5.633,4.566,10.199,10.199,10.199h491.602c5.633,0,10.199-4.566,10.199-10.199V180.04    C512,174.408,507.434,169.842,501.801,169.842z M441.159,102.623l28.879,28.879L291.797,309.745l-15.38-15.381    c-3.983-3.984-10.441-3.983-14.424,0s-3.984,10.441,0,14.424l12.63,12.63l-44.888,21.512l26.577-55.456L441.159,102.623z     M491.602,413.602H20.398V190.24h304.296l-84.04,84.04c-0.815,0.816-1.487,1.763-1.986,2.805l-37.076,77.363H66.295    c-5.633,0-10.199,4.566-10.199,10.199c0,5.633,4.566,10.199,10.199,10.199h141.724c1.493,0,2.998-0.327,4.405-1.002l83.154-39.851    c1.04-0.499,1.989-1.17,2.805-1.986L440.15,190.24h51.452V413.602z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M205.004,225.938h-5.1c-5.633,0-10.199,4.566-10.199,10.199s4.566,10.199,10.199,10.199h5.1    c5.633,0,10.199-4.566,10.199-10.199S210.637,225.938,205.004,225.938z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M156.048,225.938H66.295c-5.633,0-10.199,4.566-10.199,10.199s4.566,10.199,10.199,10.199h89.753    c5.633,0,10.199-4.566,10.199-10.199S161.681,225.938,156.048,225.938z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M205.004,290.193H66.295c-5.633,0-10.199,4.566-10.199,10.199c0,5.633,4.566,10.199,10.199,10.199h138.709    c5.633,0,10.199-4.566,10.199-10.199C215.203,294.759,210.637,290.193,205.004,290.193z" />
      </g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>;
};

SVGCheck.propTypes = {
  //
};

export default SVGCheck;
